import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';

export type MasterLookupType = 'billingCycles' | 'currencies' | 'countries' | 'timezones' | 'categories';

export interface MasterLookupListPayload {
  type: MasterLookupType;
  includeDeleted?: boolean;
  page?: number;
  limit?: number;
}

const ENDPOINT_BY_TYPE: Record<MasterLookupType, string> = {
  billingCycles: API_ENDPOINTS.billingCycles,
  currencies: API_ENDPOINTS.currencies,
  countries: API_ENDPOINTS.countries,
  timezones: API_ENDPOINTS.timezones,
  categories: API_ENDPOINTS.categories,
};

const list = (payload: MasterLookupListPayload) => {
  const { type, includeDeleted, page, limit } = payload;
  const params: Record<string, string> = {};
  if (includeDeleted) params.includeDeleted = 'true';
  if (page) params.page = String(page);
  if (limit) params.limit = String(limit);
  const query = new URLSearchParams(params).toString();
  return http.get(`${ENDPOINT_BY_TYPE[type]}${query ? `?${query}` : ''}`);
};

const get = (type: MasterLookupType, id: number | string) => http.get(`${ENDPOINT_BY_TYPE[type]}/${id}`);

const create = (type: MasterLookupType, payload: Record<string, unknown>) =>
  http.post(ENDPOINT_BY_TYPE[type], payload);

const update = (type: MasterLookupType, id: number | string, payload: Record<string, unknown>) =>
  http.patch(`${ENDPOINT_BY_TYPE[type]}/${id}`, payload);

const remove = (type: MasterLookupType, id: number | string) => http.delete(`${ENDPOINT_BY_TYPE[type]}/${id}`);

const MasterLookupService = { list, get, create, update, remove };

export default MasterLookupService;
